/* InsighTea theme JS — mobile nav, FAQ accordions, product tabs, gallery, qty */
(function () {
  'use strict';

  var cartCountRequest = 0;
  document.addEventListener('cart:update', async function (event) {
    var cartLink = document.querySelector('.it-cart');
    if (!cartLink) return;

    var request = ++cartCountRequest;
    var cart = event.detail && event.detail.resource;
    try {
      if (!cart || typeof cart.item_count !== 'number') {
        var response = await fetch(cartLink.href + '.js');
        if (!response.ok) return;
        cart = await response.json();
      }
      if (request !== cartCountRequest || typeof cart.item_count !== 'number') return;

      var count = cart.item_count;
      var badge = cartLink.querySelector('.it-cart-count');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'it-cart-count';
          badge.setAttribute('role', 'status');
          cartLink.appendChild(badge);
        }
        badge.textContent = count;
      } else if (badge) {
        badge.remove();
      }
      if (typeof Theme !== 'undefined') {
        cartLink.setAttribute('aria-label', Theme.translations.cart_count + ': ' + count);
      }
    } catch (error) {
      console.error('Unable to refresh cart count', error);
    }
  });

  var toggle = document.getElementById('ItMobileToggle');
  var mobileNav = document.getElementById('ItMobileNav');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  document.querySelectorAll('.it-faq-item').forEach(function (item) {
    var btn = item.querySelector('.it-faq-q');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var open = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  document.querySelectorAll('[data-tea-tabs]').forEach(function (group) {
    var tabs = group.querySelectorAll('.it-tea-tab');
    var panels = group.querySelectorAll('.it-tea-panel');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var name = tab.getAttribute('data-tea');
        tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
        panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-tea') === name); });
      });
    });
  });

  document.querySelectorAll('.it-product-gallery').forEach(function (gallery) {
    var mainImg = gallery.querySelector('.main-img img');
    var thumbs = Array.from(gallery.querySelectorAll('.thumb'));
    var dialog = gallery.querySelector('.it-gallery-dialog');
    var openButton = gallery.querySelector('[data-gallery-open]');
    var closeButton = gallery.querySelector('[data-gallery-close]');
    var dialogImage = gallery.querySelector('.it-gallery-dialog-image');

    function selectImage(thumb) {
      var src = thumb.getAttribute('data-src');
      if (!mainImg || !src) return;

      var picture = mainImg.closest('picture');
      if (picture) picture.querySelectorAll('source').forEach(function (source) { source.remove(); });
      ['srcset', 'sizes', 'width', 'height'].forEach(function (attribute) {
        var value = thumb.getAttribute('data-' + attribute);
        if (value) mainImg.setAttribute(attribute, value);
        else mainImg.removeAttribute(attribute);
      });
      mainImg.src = src;
      mainImg.alt = thumb.getAttribute('data-alt') || '';
      thumbs.forEach(function (button) {
        var active = button === thumb;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () { selectImage(thumb); });
      thumb.addEventListener('keydown', function (event) {
        if (event.altKey || event.ctrlKey || event.metaKey) return;
        var next;
        if (event.key === 'ArrowRight') next = (index + 1) % thumbs.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + thumbs.length) % thumbs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = thumbs.length - 1;
        else return;
        event.preventDefault();
        thumbs[next].focus();
        selectImage(thumbs[next]);
      });
    });

    if (mainImg && dialog && openButton && closeButton && dialogImage && typeof dialog.showModal === 'function') {
      openButton.hidden = false;
      openButton.addEventListener('click', function () {
        if (dialog.open) return;
        var enlarged = mainImg.cloneNode();
        enlarged.removeAttribute('srcset');
        enlarged.removeAttribute('sizes');
        enlarged.removeAttribute('loading');
        enlarged.removeAttribute('fetchpriority');
        dialogImage.replaceChildren(enlarged);
        dialog.showModal();
        closeButton.focus();
      });
      closeButton.addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('close', function () { openButton.focus(); });
    }
  });

  document.querySelectorAll('.it-qty').forEach(function (qty) {
    var input = qty.querySelector('input');
    qty.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var delta = btn.getAttribute('data-action') === 'plus' ? 1 : -1;
        var v = parseInt(input.value || '1', 10) + delta;
        if (v < 1) v = 1;
        input.value = v;
      });
    });
  });
})();

